export default "__VITE_ASSET__BV6wFzY3__"